export default __webpack_public_path__ + "static/terraform-d82e367b69d00d0b08060629b3e269da.png";